module.exports = __webpack_public_path__ + "img/icon1.315169de.png";